'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _entrySeq2 = require('./internal/_entrySeq');

var _entrySeq3 = _interopRequireDefault(_entrySeq2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Get a Seq of the entries (i.e. [key, value] tuples) in `subject`.
 *
 * @example
 * entrySeq(Map({one: 1, two: 2}))
 * // returns Seq [ ['one', 1], ['two', 2] ]
 *
 * @param  {Array|Iterable|Object} subject
 * @return {Seq}
 */
exports.default = _entrySeq3.default;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/entrySeq.js
// module id = 348
// module chunks = 0 1